// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"bc27e9fd","194":"3625818c","233":"c1bfd2bc","513":"b540e873","703":"24a3e026","787":"3abbbd8c"}[chunkId] + ".chunk.js";
};